<template>
  <div class="animated fadeIn step-container plan-payment">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h2 class="text-center">My subscription</h2>
      </div>
      
      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">รายละเอียดบริการ</h4>
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Detail</th>
                  <th>Start Date</th>
                  <th>Expired Date</th>
                  <th>Status</th>
                  <th>Bill</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="sub in doctor.subscriptions">
                  <td>{{sub.id}}</td>
                  <td>
                    {{plans[sub.plan_id-1].name}}<br>
                    {{plans[sub.plan_id-1].detail}}<br>
                    {{plans[sub.plan_id-1].duration}}<br>
                  </td>
                  <td>{{sub.started_at}}</td>
                  <td>{{sub.expired_at}}</td>
                  <td><span class="badge badge-success"> Active</span></td>
                  <td><a href=""><i class="fa fa-download" aria-hidden="true"></i> Receipt</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Step from '@/components/StepBar'

export default {
  components: {
    Step
  },
  data () {
    return {
      doctor: {},
      plans: [
        {
          id: 1,
          name: 'Basic Plan (subscription)',
          detail: '499 (per month) x 3 months',
          duration: '3 เดือน',
          price: 1497
        },
        {
          id: 2,
          name: 'Advance Plan (subscription)',
          detail: '฿399 (per month) x 12 months',
          duration: '1 ปี',
          price: 4788
        },
        {
          id: 3,
          name: 'Pro Plan (subscription)',
          detail: '฿299 (per month) x 36 months',
          duration: '3 ปี',
          price: 10764
        }
      ]
    }
  },
  created () {
    this.$http.get(this.$APP_CONFIG.api.admin.doctorme(), { credentials: true }).then(res => {
      this.doctor = res.body.data
    })
  }
}
</script>

<style lang='scss'>
.step-body{
  background-color: #fff;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// MySubscription.vue?1fbfe7dd